import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[mweSetFocus]',
  exportAs: 'mweSetFocus',
})
export class SetFocusDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  focus() {
    this.renderer.selectRootElement(this.el.nativeElement, true).focus();
  }
}
